export default class RentMachineCategorySerializer {
    static serialize(rentMachine) {
        return rentMachine;
    }

    static unserialize(rentMachine) {
        return rentMachine
    }
}


// WEBPACK FOOTER //
// ./web/src/services/rent-machine/RentMachineCategorySerializer.js